import {
  BooleanSchema,
  DateSchema,
  ISchema,
  MixedSchema,
  NumberSchema,
  StringSchema,
  YupArraySchema,
  isYupArraySchema,
} from '@framework/validation';
import { useMemo } from 'react';

export interface IFieldSchemaValidation {
  required?: boolean;
  stripped?: boolean;
}

/**
 * Ottiene e memoizza i dettagli di validazione di uno schema, solamente
 * per i tipi di schema supportati, ovvero quelli primitivi.
 */
export function useFieldSchemaValidation(
  schema: ISchema<any> | Array<ISchema<any>> | null | undefined,
): IFieldSchemaValidation {
  return useMemo(() => getFieldSchemaValidation(schema), [schema]);
}

/**
 * Funzione per ottenere i dettagli di validazione di uno schema, solamente
 * per i tipi di schema supportati, ovvero quelli primitivi.
 */
export function getFieldSchemaValidation(
  schema: ISchema<any> | Array<ISchema<any>> | null | undefined,
): IFieldSchemaValidation {
  if (!schema) return {};
  // TODO Aggiungere la gestione dei tipi di schema, es `ObjectSchema`
  const input = Array.isArray(schema) ? schema : [schema];

  const schemas = input.flatMap(getPlainSchema);
  const descriptions = schemas.map(getPlainSchemaDescription);

  return {
    required: descriptions.some(d => !d.optional),
    stripped: schemas.some(s => s.spec?.strip),
  };
}

function getPlainSchema(schema: ISchema<any>) {
  if (
    schema instanceof NumberSchema ||
    schema instanceof DateSchema ||
    schema instanceof BooleanSchema ||
    schema instanceof StringSchema ||
    schema instanceof MixedSchema ||
    isYupArraySchema(schema)
  ) {
    return [schema];
  }

  return [];
}

function getPlainSchemaDescription(
  schema:
    | NumberSchema
    | DateSchema
    | BooleanSchema
    | StringSchema
    | YupArraySchema<any>
    | MixedSchema,
) {
  return schema.describe();
}
